export enum CheckoutIntegrationStatus {
	REJECTED = 'rejected',
	CANCELED = 'canceled',
	SENT = 'sent',
}
